import React, { ReactNode, useEffect, useRef, useState } from "react";

import { Carousel } from "react-responsive-carousel";
import { GeneralObject } from "../../../definitions/general";
import { GenericImageSlideshow } from "../ImageSlideshow";
import Flex from "../../structure/Flex";

interface ImageCarouselProps {
  images: string[];
  height?: string;
  carouselProps?: GeneralObject;
  imageFit?: "contain" | "cover";
  showTitle?: boolean;
  isSlideshow?: boolean;
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({
  images,
  carouselProps,
  height,
  imageFit,
  showTitle,
  isSlideshow,
}) => {
  const [slideshowVisible, setSlideshowVisible] = useState<boolean>(false);
  const selectedItem = useRef<number>(0);
  const ref = useRef<HTMLImageElement | null>(null);

  const [clientWidth, setClientWidth] = useState<number | null>();

  useEffect(() => {
    setClientWidth(ref.current?.clientWidth);
  }, []);

  const handleClick = (index: number, item: ReactNode) => {
    console.log(index, item);
    selectedItem.current = index;
    setSlideshowVisible(true);
  };

  return (
    <>
      <Carousel {...carouselProps} onClickItem={handleClick}>
        {images.map((image, index) => (
          <Flex
            items="center"
            justify="center"
            className={`w-full h-full ${isSlideshow ? "py-8" : ""}`}
            style={{ maxHeight: "80vh" }}
            key={`${index}`}
          >
            <img
              src={
                clientWidth
                  ? `${image}${
                      isSlideshow
                        ? "?w=1280"
                        : ref.current
                        ? `?w=${Math.ceil(clientWidth / 50) * 50}`
                        : ""
                    }`
                  : ""
              }
              alt=""
              ref={ref}
              className={`w-full ${height ? height : "h-full"} ${
                imageFit === "contain" ? "object-contain" : "object-cover"
              } object-center cursor-zoom-in`}
            />
            {showTitle && (
              <p
                className={isSlideshow ? "legend ss-legend" : "legend"}
                style={{
                  color: "#fefefe",
                  opacity: 1,
                  backgroundColor: "rgba(0,0,0,0.25)",
                }}
              >
                {image.split("/")[-1]}
              </p>
            )}
          </Flex>
        ))}
      </Carousel>
      {slideshowVisible && (
        <GenericImageSlideshow
          close={setSlideshowVisible.bind(null, false)}
          images={images}
          carouselProps={{
            showIndicators: false,
            selectedItem: selectedItem.current,
            infiniteLoop: true,
          }}
        />
      )}
    </>
  );
};

export default ImageCarousel;
